import { Component } from '@angular/core';
import * as tooltips from '../../../constants/tooltips';

@Component({
    selector: 'cdp-promoter-type-warning-chip',
    templateUrl: './promoter-type-warning-chip.component.html',
    styleUrl: './promoter-type-warning-chip.component.scss',
    standalone: false
})
export class PromoterTypeWarningChipComponent {
    tooltips = tooltips;
}
